export default function Calendar({ id, handler, validation, error }) {
    return (
        <div id={id}>
            <input type="date"
                id={id}
                {...validation} // This includes onChange, ref, name, etc.
                onChange={(e) => {
                    validation.onChange?.(e);
                    handler?.(e);
                }}
                name={validation.name}
                ref={validation.ref}
            ></input>
           {error && <div className="error-text">{error.message}</div>}
        </div>
    )
}

